export enum ApiVersions {
  v0_1 = 'v0.1',
  v1_0 = 'v1.0',
  unversioned = 'unversioned'
}
